/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function ChartUpwardIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "chart-upward", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M5.5 5V19.5H20", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M7.5 16L11.5 11.5L15.5 14L19.5 8.5", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(ChartUpwardIcon);
export default ForwardRef;
//# sourceMappingURL=chartUpwardIcon.js.map